/* =========================================================================
   ClueVine — How-to-play steps
   The numbered rule list shared by the per-mode How-to modal and the full
   How-to-play guide screen, so both render a mode's steps identically. The
   step number tints to the surrounding --accent when one is set (guide cards),
   and falls back to vine inside the plain modal.
   ========================================================================= */

import type { CSSProperties } from 'react';
import type { HowToStep } from '../engine/types';

const numStyle: CSSProperties = {
  flexShrink: 0,
  display: 'grid',
  placeItems: 'center',
  width: '1.7rem',
  height: '1.7rem',
  borderRadius: '999px',
  background: 'var(--accent-wash, var(--vine-wash))',
  color: 'var(--accent, var(--vine))',
  fontFamily: 'var(--font-mono)',
  fontWeight: 500,
  fontSize: 'var(--text-sm)',
};

export function HowToSteps({ steps }: { steps: HowToStep[] }) {
  return (
    <ol
      className="cv-stack"
      style={{ margin: 0, paddingLeft: 0, listStyle: 'none', gap: 'var(--space-md)' }}
    >
      {steps.map((step, i) => (
        <li key={i} className="cv-row" style={{ alignItems: 'flex-start', gap: 'var(--space-sm)' }}>
          <span style={numStyle}>{i + 1}</span>
          <span>
            <strong>{step.title}.</strong> <span className="cv-muted">{step.body}</span>
          </span>
        </li>
      ))}
    </ol>
  );
}
